import { DataTable } from '../../../../../../../components/UI/MDC/DataTable/DataTable';
import AppDataForm from './AppDataForm';
import AppDataDeactivationButton from './AppDataDeactivationButton';
const AppDataDisplay = ({
	component,
	app,
	currentUser,
	reload,
	readOnly,
	requirementNumber,
}) => {
	const headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Description', props: { sort: null, onSortChange: null } },
		{ Value: 'Field Value', props: { sort: null, onSortChange: null } },
		{ Value: 'Extension ID', props: { sort: null, onSortChange: null } },
	];

	const rows = component.appData.map((data, index) => {
		return {
			Cells: {
				Actions: {
					Value: (
						<>
							<AppDataForm
								appData={data}
								app={app}
								currentUser={currentUser}
								component={component}
								reload={reload}
								requirementNumber={requirementNumber}
								readOnly={readOnly}
							/>
							<AppDataDeactivationButton
								appData={data}
								app={app}
								currentUser={currentUser}
								component={component}
								reload={reload}
								requirementNumber={requirementNumber}
								readOnly={readOnly}
							/>
						</>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				ID: {
					Value: data.id,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Description: {
					Value: data.description,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Field Value': {
					Value: data.fieldValue,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Extension ID': {
					Value: data.extension?.fiid,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: data.id.toString(),
		};
	});

	return (
		<>
			<DataTable rows={rows} headers={headers} />
			{/* {new app data form} */}
			<AppDataForm
				app={app}
				currentUser={currentUser}
				component={component}
				reload={reload}
				readOnly={readOnly}
				requirementNumber={requirementNumber}
			/>
		</>
	);
};

export default AppDataDisplay;
